var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
var locals_ = (locals || {}),schema = locals_.schema,value = locals_.value,record = locals_.record,time = locals_.time;
var jade_indent = [];
buf.push("\n<div class=\"row\">\n  <div class=\"col-lg-12\">\n    <div style=\"display: none\" class=\"alert alert-danger\"></div>\n    <form class=\"form-horizontal\">");
// iterate schema.properties
;(function(){
  var $$obj = schema.properties;
  if ('number' == typeof $$obj.length) {

    for (var name = 0, $$l = $$obj.length; name < $$l; name++) {
      var property = $$obj[name];

value = record.properties[name]
buf.push("\n      <div class=\"form-group\">\n        <label class=\"field-name col-lg-4\">" + (jade.escape((jade_interp = name.replace(/_/g, ' ')) == null ? '' : jade_interp)) + "</label>\n        <div class=\"col-lg-8\">");
if (property.type == 'integer' || property.type == 'float')
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("value", "" + (value) + "", true, false)) + " class=\"form-control\"/>");
}
else if (property.type == 'boolean')
{
buf.push("\n          <label class=\"radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"1\"" + (jade.attr("checked", value, true, false)) + "/>YES\n          </label>\n          <label class=\"radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"0\"" + (jade.attr("checked", !value, true, false)) + "/>NO\n          </label>");
}
else if (property.type == 'timestamp')
{
if (value && value.toString().length == 10) value = value * 1000
time = value ? this.moment(value).format("YYYY-MM-DD HH:mm:ss ZZ") : ''
buf.push("\n          <div class=\"input-group date\">\n            <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("value", "" + (time) + "", true, false)) + " class=\"form-control\"/><span class=\"input-group-addon\"><i class=\"fa fa-th\"></i></span>\n          </div>");
}
else
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("value", "" + (value) + "", true, false)) + " class=\"form-control\"/>");
}
buf.push("\n        </div>\n      </div>");
    }

  } else {
    var $$l = 0;
    for (var name in $$obj) {
      $$l++;      var property = $$obj[name];

value = record.properties[name]
buf.push("\n      <div class=\"form-group\">\n        <label class=\"field-name col-lg-4\">" + (jade.escape((jade_interp = name.replace(/_/g, ' ')) == null ? '' : jade_interp)) + "</label>\n        <div class=\"col-lg-8\">");
if (property.type == 'integer' || property.type == 'float')
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("value", "" + (value) + "", true, false)) + " class=\"form-control\"/>");
}
else if (property.type == 'boolean')
{
buf.push("\n          <label class=\"radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"1\"" + (jade.attr("checked", value, true, false)) + "/>YES\n          </label>\n          <label class=\"radio-inline\">\n            <input type=\"radio\"" + (jade.attr("name", "" + (name) + "", true, false)) + " value=\"0\"" + (jade.attr("checked", !value, true, false)) + "/>NO\n          </label>");
}
else if (property.type == 'timestamp')
{
if (value && value.toString().length == 10) value = value * 1000
time = value ? this.moment(value).format("YYYY-MM-DD HH:mm:ss ZZ") : ''
buf.push("\n          <div class=\"input-group date\">\n            <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("value", "" + (time) + "", true, false)) + " class=\"form-control\"/><span class=\"input-group-addon\"><i class=\"fa fa-th\"></i></span>\n          </div>");
}
else
{
buf.push("\n          <input type=\"text\"" + (jade.attr("name", "" + (name) + "", true, false)) + (jade.attr("value", "" + (value) + "", true, false)) + " class=\"form-control\"/>");
}
buf.push("\n        </div>\n      </div>");
    }

  }
}).call(this);

buf.push("\n    </form>\n  </div>\n</div>");;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}